import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
// import { NotificationsService } from 'angular2-notifications';
import { BaseDataService, BaseUpdateComponent, NotificationService } from 'yt-ng-framework';
import { VrstaStavkiKodKupca } from './vrsta-stavki-kod-kupca';
import { VrstaStavkiKodKupcaView } from './vrsta-stavki-kod-kupca-view';
// import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'yt-vrsta-stavki-kod-kupca-update',
  templateUrl: './vrsta-stavki-kod-kupca-update.component.html'
})
export class VrstaStavkiKodKupcaUpdateComponent extends BaseUpdateComponent<VrstaStavkiKodKupca> implements OnInit {

  constructor(
    protected activatedRoute: ActivatedRoute,
    protected baseDataService: BaseDataService,
    // protected notificationService: NotificationsService,
    protected toastrService: NotificationService,
    protected translateService: TranslateService
  ) {
    super(activatedRoute, baseDataService, toastrService, translateService)
   }

   vrstaStavki: string = "";

  ngOnInit() {
    super.ngOnInit();
    this.addValidatorToFc('VrstaStavkiId', Validators.required, 'required', 'VRSTASTAVKIKODKUPCA.VRSTASTAVKI.VALIDATION.REQUIRED');
    this.addValidatorToFc('KomitentId', Validators.required, 'required', 'VRSTASTAVKIKODKUPCA.KOMITENT.VALIDATION.REQUIRED');
    this.addValidatorToFc('SifraKodKomitenta', Validators.required, 'required', 'VRSTASTAVKIKODKUPCA.SIFRAKODKOMITENTA.VALIDATION.REQUIRED');
  }

  onVrstaStavkiSelected(value: VrstaStavkiKodKupcaView){
    if (value)
      this.vrstaStavki = value.VrstaStavki
  }

}
